/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
     File Description : Footer bar for content block Add | Edit Page
 --------------------------------------------------------------------------------- 
    Creation Details 
    Date Created				: 12/April/2022
    Author						  : Amrutesh Devadas
================================================================ 
*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hideSnippetFunction } from "../../../../components/utility/hideSnippetFunction";
import { accessRightActionCheck, getProductVariant } from "utilities";
import { COMMON_ACCESS_ACTION, SUCCESS_TREND, PRODUCT_VARIANT } from "../../../../../constants";
import { updateTrends } from "middleware/services/contentBlockApi";
import { actionSuccess, actionError } from "middleware/actions/utilityAction";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const FooterBar = (props) => {
  const dispatch = useDispatch();

  const productVariant = getProductVariant();

  const { selectedIndex, contentBlockStatus } = props;

  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  let interfaceAccessSave = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SAVE);
  let interfaceAccessSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SUBMIT);
  let interfaceAccessApprove = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.APPROVE);
  let interfaceAccessPublish = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.PUBLISH);
  let interfaceAccessReject = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.REJECT);

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props.hashArr)[props.selectedIndex];
    let actionAccess = accessRightActionCheck(props.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props.selectedIndex]);

  const udpateTempTrends = async () => {
    await updateTrends(props.contentBlockId)
      .then((res) => {
        if (res) {
          dispatch(actionSuccess(SUCCESS_TREND));
        } else {
          dispatch(actionError("Something went wrong"));
        }
      })
      .catch((err) => {
        dispatch(actionError(err?.data?.message || "Something went wrong"));
      });
  };

  return (
    <div className="form-submit-box">
      <div
        // className={`float-LEFT  text-left pl-0 ${props.selectedIndex > -1 && props.selectedIndex < 3 ? "col-md-3" : "col-md-2"}`}
        // style={{ paddingRight: "0px" }}
        className="footer-layout"
      >
        {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
          <button
            type="button"
            className="cy-prev-btn btn btn-outline-dark cy-btn"
            onClick={() => {
              (props.selectedIndex === undefined && props.setCurrentTab(2)) ||
                (props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex - 1));
            }}
          >
            Previous
          </button>
        ) : null}
        {props.contentBlockId !== "" && props.selectedIndex > -1 && props.selectedIndex < 3 ? (
          <button
            type="button"
            className="cy-next-btn btn btn-outline-dark cy-btn"
            onClick={() => {
              props.selectedIndex < 3 && props.setCurrentTab(props.selectedIndex + 1);
            }}
          >
            Next
          </button>
        ) : null}
      </div>
      {/* <div className={`float-right  text-right px-0 ${props.selectedIndex > -1 && props.selectedIndex < 3 ? "col-md-9" : "col-md-10"}`}> */}
      <div className="footer-layout">
        <Link to="/content-block">
          <button type="button" className="btn btn-outline-dark cy-btn">
            Cancel
          </button>
        </Link>
        {props.selectedIndex !== 3 && interfaceAccessSave && ["In Progress", "", "Rejected"].includes(contentBlockStatus) ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              props.handleSave(true);
            }}
          >
            Save
          </button>
        ) : null}
        {interfaceAccessSubmit && ["In Progress", "", "Rejected"].includes(contentBlockStatus) && (selectedIndex === 2 || selectedIndex === 1) ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              hideSnippetFunction();
              props.setViewBlocks(false);
              props.handleSubmit();
            }}
          >
            Submit
          </button>
        ) : null}
        {interfaceAccessReject && (selectedIndex === 2 || selectedIndex === 1) ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              hideSnippetFunction();
              props.setViewBlocks(false);
              props.handleReject();
            }}
          >
            Reject
          </button>
        ) : null}
        {interfaceAccessApprove && (selectedIndex === 2 || selectedIndex === 1) ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-news-save"
            onClick={() => {
              hideSnippetFunction();
              props.handleApprove();
              props.setViewBlocks(false);
            }}
          >
            Approve
          </button>
        ) : null}
        {interfaceAccessPublish && (selectedIndex === 2 || selectedIndex === 1) ? (
          <button
            type="button"
            className="btn btn-primary cy-btny"
            id="dev-news-save"
            onClick={() => {
              hideSnippetFunction();
              props.setViewBlocks(false);
              props.handlePublish();
            }}
          >
            Publish
          </button>
        ) : null}
        {props.selectedIndex == 3 && productVariant === PRODUCT_VARIANT.INSIDER ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-objective-save"
            onClick={() => {
              udpateTempTrends();
              props.setSaveTrendTreeData(true);
            }}
          >
            Save
          </button>
        ) : null}
      </div>
    </div>
  );
};

FooterBar.propTypes = {
  setSaveTrendTreeData: PropTypes.func,
  contentBlockId: PropTypes.string,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
  handleSubmit: PropTypes.func,
  setViewBlocks: PropTypes.func,
  handleReject: PropTypes.func,
  handlePublish: PropTypes.func,
  handleSave: PropTypes.func,
  handleApprove: PropTypes.func,
};

export default FooterBar;
